import React from "react";

export default function () {
    return (
        <React.Fragment>
            <p>&nbsp;</p>
            <h1>Welcome to The Right Math Class&trade;!</h1>
            <p>
                The Right Math Class&trade; is an online first-year Math course
                placement tool that creates a personalized course placement by
                integrating and analyzing the following (as applicable):
            </p>
            <ul>
                <li>Historical Information:</li>
                <ul>
                    <li>High school Math courses and grades therein</li>
                    <li>High school GPA</li>
                    <li>Standardized test scores</li>
                </ul>
            </ul>
            <ul>
                <li>Self evaluation of self-efficacy:</li>
                <ul>
                    <li>
                        Level of confidence in ability to be successful in math
                    </li>
                    <li>Academic skills</li>
                </ul>
            </ul>

            <p>
                The Right Math Class&trade; will provide you with a placement
                level (and a list of appropriate courses) that in general is
                quite appropriate for your experiences with mathematics.
            </p>

            <p>
                This process will take between 5-10 minutes. Please be sure you
                have the time to answer all questions before beginning. The
                Right Math Class™ does not allow for multiple attempts.
            </p>

            <p>
                Consider also taking the Accuplacer placement test (which is a
                more in-depth evaluation of math skills) if after completing The
                Right Math Class&trade; you believe you have the skills and
                confidence to be successful at a level higher than that provided
                by The Right Math Class&trade;. You will be provided with
                additional information with your results.
            </p>

            <p>
                If you already have credits for College Level Math either
                through AP/IB testing or through coursework at another college
                or university (including dual enrollment credit), you will
                receive more information about your options at the end of this
                process.
            </p>

            <p>
                <b>Honor Code Agreement</b>
            </p>
            <p>
                As a member of the Boise State community, you are obligated to
                abide by Boise State's{" "}
                <a
                    href="https://deanofstudents.boisestate.edu/academic-integrity/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Academic Honesty policy
                </a>{" "}
                and to honor the campus-wide Core Values, which include
                trustworthiness, academic excellence, and responsibility.
            </p>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/boisestatemath/siteComponents/auth.js